import { useState, useEffect } from "react";

const OurStory = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="bg-white py-10 px-4 sm:px-8 lg:px-20 overflow-hidden">
      <div className=" mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-center">

          {/* ── LEFT: Text Content ── */}
          <div
            className="lg:col-span-1 flex flex-col gap-5"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateX(0)" : "translateX(-40px)",
              transition: "opacity 0.7s ease, transform 0.7s ease",
            }}
          >
            <p className="text-sm font-semibold uppercase tracking-widest text-orange-500">
              Our story
            </p>

            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">
              It feels like family <br className="hidden sm:block" />
              (because it is)
            </h2>

            <div className="text-gray-500 text-sm leading-relaxed space-y-3">
              <p>
                There are many variations of passages of Lorem Ipsum available, but the majority
                have suffered alteration in some form, by injected humour, or randomised words
                which don't look even slightly believable.
              </p>
              <p>If you are going to use a passage of Lorem Ipsum</p>
            </div>

            <div>
              <a
                href="#"
                className="inline-block mt-2 px-6 py-2.5 text-sm font-semibold text-gray-900 border-2 border-gray-900 rounded-full hover:bg-gray-900 hover:text-white transition-all duration-300"
              >
                Read more
              </a>
            </div>
          </div>

          {/* ── MIDDLE: Image (fade down) ── */}
          <div
            className="lg:col-span-1 flex justify-center"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(-40px)",
              transition: "opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s",
            }}
          >
            <img
              src="https://varanasitemples.in/wp-content/uploads/2010/05/Tripura-Bhairavi-1-756x1024.jpg"
              alt="Our Story"
              className="w-full rounded-2xl object-cover shadow-lg"
              style={{ height: "420px" }}
            />
          </div>

          {/* ── RIGHT: Image (fade up) ── */}
          <div
            className="lg:col-span-1 flex justify-center"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(40px)",
              transition: "opacity 0.7s ease 0.4s, transform 0.7s ease 0.4s",
            }}
          >
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYzO3q1mb7W8lMrfSc5mRZP6JXv0dOWQ2Ang&s"
              alt="Our Story"
              className="w-full rounded-2xl object-cover shadow-lg"
              style={{ height: "420px" }}
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default OurStory;